// extracted by mini-css-extract-plugin
module.exports = {"swap":"Swap-module--swap--3oIRM","swapButton":"Swap-module--swapButton--2famc"};